// Description: Fixed viewport that renders the stack and handles pause-on-hover

// Import React and the toast context hook
import React, { useRef } from "react";
import { useToastContext } from "../context/ToastProvider";
import Toast from "./Toast";
import "./Toast.css";


// Export the fixed-position container to mount once near the root
export default function ToastContainer() {
// Access toasts and remove action from context
const { toasts, removeToast } = useToastContext();
// Create a ref to mark when user is hovering over the container
const hoveringRef = useRef(false);
// Render the container and map each toast to a Toast item
return (
<div
className="toast-viewport toast-viewport--br"
onMouseEnter={() => (hoveringRef.current = true)}
onMouseLeave={() => (hoveringRef.current = false)}
aria-live="polite"
aria-relevant="additions removals"
>
{toasts.map((t) => (
<Toast key={t.id} toast={t} onDismiss={() => removeToast(t.id)} />
))}
</div>
);
}